export default __webpack_public_path__ + "static/media/postman-logo.15502aeb.jpeg";